import styled from "@emotion/styled"
import HomePageLinkUI from "layout/HomePageLinkUI"
import { ParentPage } from "lib/utils"
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper"
import ScrollProviderMobile from "pazChargeComponents/general/ScrollProviderMobile"
import SmallChargeIcon from "public/icons/pazCharge/Logo/smallChargeLogo"
import { CustomBreadcrumbs, ImageContainer, NewText, TitleWithLine, extractProperty } from "ui"

const StyledWrapper = styled.div`
    padding-left: 20px;
${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 100px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 220px;
  }
`
const StyledTitleAndText = styled.div<{ titleMargin: Boolean }>`
padding-top: 10px;
padding-bottom: 20px;
${(props) => props.theme.breakpoints.up("md")} {
    ${(props) => props.titleMargin && "padding-left: 50px;"}
    padding-top: 40px;
    padding-bottom: 40px;
    ${(props) => props.titleMargin && "margin: auto;"}
  }
`

type Props = {
    data: any,
    titleMargin?: boolean
    pageName?: string
    spaceBetweenTextToLine?: number
    showMobileScroll?: boolean
    parents?: ParentPage[]
}
function ImageWithTextCharge({ data, titleMargin = false, pageName, spaceBetweenTextToLine, showMobileScroll = false, parents = [] }: Props) {

    const heroBannerDescktop = extractProperty(data, "heroBannerDescktop")
    const heroBannerMobil = extractProperty(data, "heroBannerMobil")
    const pageMainTitle = extractProperty(data, "pageMainTitle")
    const subTitle = extractProperty(data, "subTitle")

    return (
        <>
            <StyledWrapper>
                <CustomBreadcrumbs
                    current={{ title: pageName || pageMainTitle, url: `/` }}
                    firstItemIconText
                    firstIconText="בית"
                    firstItemIconTextUnderline
                    parents={[{
                        title: <HomePageLinkUI title="ראשי" icon={<SmallChargeIcon />}/>,
                        url: "/pazcharge"
                    }, ...parents.slice(0, -1)]}
                />
                <ImageContainer
                    desktopUrl={heroBannerDescktop}
                    mobileUrl={heroBannerMobil}
                    sm={true}
                    objectPosition="right top"
                    height={500}
                    mobileHeight={420}

                />
            </StyledWrapper>
            <ContainerWrapper>
                <StyledTitleAndText
                    titleMargin={titleMargin}>
                    <TitleWithLine
                        title={pageMainTitle}
                        component={"h1"}
                        titleColor="black"
                        titleFontSize={48}
                        desktopLineHeight="50px"
                        mobileTitleFontSize={28}
                        spaceBetweenTextToLine={spaceBetweenTextToLine}
                    />
                    <NewText
                        component={"p"}
                        largeDesktopFontSize={18}
                        largeDesktopLineHeight="20px"
                        desktopFontSize={18}
                        desktopLineHeight={"20px"}
                        desktopFontWeight={400}
                        mobileFontSize={16}
                        mobileLineHeight={"18px"}
                        mobileFontWeight={400}
                        style={{ paddingTop: 10 }}
                    >
                        {subTitle}
                    </NewText>
                </StyledTitleAndText>
            </ContainerWrapper>
            {showMobileScroll && <ScrollProviderMobile />}
        </>
    )
}

export default ImageWithTextCharge
